import {
  ApolloClient,
  InMemoryCache,
  createHttpLink,
  split
} from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { createClient } from 'graphql-ws';
import { getMainDefinition } from '@apollo/client/utilities';

const httpLink = createHttpLink({
  // npm run build (produccion) usa REACT_APP_URI_PROD; npm start usa REACT_APP_URI_DEV
  uri: process.env.NODE_ENV === 'production'
    ? process.env.REACT_APP_URI_PROD
    : process.env.REACT_APP_URI_DEV
});

// Auth header — JWT propio (sin Auth0)
const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem('nawi_office_token');
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : ''
    }
  };
});

const wsLink = new GraphQLWsLink(
  createClient({
    url: process.env.REACT_APP_URI_SUSCRIPTION_P, 
  })
);

// split: usa wsLink solo para operaciones de tipo "subscription"
const splitLink = split(
  ({ query }) => {
    const def = getMainDefinition(query);
    return (
      def.kind === 'OperationDefinition' &&
      def.operation === 'subscription'
    );
  },
  wsLink,
  authLink.concat(httpLink)  // ← auth header en todas las requests HTTP
);

const client = new ApolloClient({
  link: splitLink,
  cache: new InMemoryCache(),
});

export default client;